import React, {Component} from 'react';
import {Button, Checkbox} from 'antd';
import SATimePicker from "../common/input/SATimePicker";
import {injectIntl} from 'react-intl';
import PropTypes from "prop-types";
import SAInputCurrency from "../common/input/SAInputCurrency";
import Time from '../../services/Time'
import LabelEncoder from "./LabelEncoder";
import SAInputDistance from "../common/input/SAInputDistance";
import Constants from "../../services/Constants";

import './CheckboxItem.css';
import PriceTag from '../common/pricetag/PriceTag';

class CheckboxItem extends Component {

  constructor(props){
    super(props);
    const active = props.item && (props.item.default === true || props.item.active);
    const duration = props.item && props.item.duration;
    const id = props.item && props.item.id;
    const price = props.item && props.item.price;
    const description = props.item && props.item.description;
    const rangeOfKilometers = props.item && props.item.rangeOfKilometers;
    const def = props.item && props.item.default;
    const name= props.name;
    const order= props.item && props.item.order;
    this.state = {
      item: {
        active,
        duration,
        id,
        price,
        description,
        rangeOfKilometers,
        default:def,
        name,
        order
      }
    };
    this.props.onChange(this.props.name, this.state.item)
  }

  onCheckboxChange = (e) => {
    const {item} = this.state;
    item.active = e.target.checked;
    this.setState({item});
    this.props.onChange(this.props.name, item);
  }

  onTimePickerChange = (time, timeString) => {
    const {item} = this.state;
    const duration = time ? `PT${time.hour()}H${time.minute()}M` : undefined;
    item.duration = duration;
    this.setState({item});
    this.props.onChange(this.props.name, item);
  }

  onInputRangeChange = (number) => {
    const {item} = this.state;
    item.rangeOfKilometers = number;
    this.setState({item});
    this.props.onChange(this.props.name, item);
  }

  onInputPriceChange = (number) => {
    const {item} = this.state;
    item.price = number;
    this.setState({item});
    this.props.onChange(this.props.name, item);
  }

  onLanguageChoiceValidation = (values) => {
    const {item} = this.state;
    item.description = values;
    this.setState({item});
    this.props.onChange(this.props.name, item);
  }

  renderLanguageChoice = () => {
    const {intl: {formatMessage}, intl} = this.props;
    const {item} = this.state;

    if (!item.description) {
      return null;
    }

    return <p>{formatMessage({id: `${intl.locale}`})} : {item.description[intl.locale]}</p>
    // const elements = [];
    // supportedLanguages.forEach(lg => {
    //   elements.push(<p key={lg}>{formatMessage({id: `${lg}`})} : {item.description[lg]}</p>)
    // });
    // return [elements];
  };

  render(){
    const {intl:{formatMessage}, placeholderDurationKey, placeholderPriceKey, placeholderKilometersKey, labelKey, config, name, error={}} = this.props;
    const {item} = this.state;

    const defaultService = this.props.item && this.props.item.default;
    return <span>
      {this.props.canWrite
        ?
          <span>
            <Checkbox name={`${name}.active`} onChange={this.onCheckboxChange} disabled={defaultService} checked={item.active}>{formatMessage({id:labelKey})}</Checkbox>
          </span>
        :
        <span>
          <Checkbox disabled={true} checked={item.active}>{formatMessage({id:labelKey})}</Checkbox>
        </span>
      }

      {config.timePicker &&
      <span>
        {this.props.canWrite && <span>
          <SATimePicker  name={`${name}.duration`} onChange={this.onTimePickerChange} className={"right"} placeholder={formatMessage({id:placeholderDurationKey})}
                         value={item.duration ? item.duration : ''} disabled={!item.active}
                         error={error[`${name}.duration`]}/>
        </span>}
        {!this.props.canWrite && <span className="right picker-right">{(item.duration) ? Time.durationToMoment(item.duration, 'HH:mm').format('HH:mm') : ''}</span>}
      </span>
      }

      {config.price &&
      <span>
        {this.props.canWrite && <span>
          <SAInputCurrency name={`${name}.price`} onChange={this.onInputPriceChange} className={"right " + (error[`${name}.price`] ? "error" : "")}
                           value={item.price ? item.price: undefined} placeholder={formatMessage({id:placeholderPriceKey})}
                           disabled={!item.active} error={error[`${name}.price`]} />
        </span>}
        {!this.props.canWrite && <span className="right picker-right"><PriceTag price={item.price}/></span>}
        </span>
      }

      {config.range &&
      <span>
         {this.props.canWrite && <span>
          <SAInputDistance name={`${name}.rangeOfKilometers`} onChange={this.onInputRangeChange} className={"right " + (error[`${name}.price`] ? "error" : "")}
                          value={item.rangeOfKilometers ? item.rangeOfKilometers : undefined} placeholder={formatMessage({id:placeholderKilometersKey})}
                          disabled={!item.active} error={error[`${name}.rangeOfKilometers`]} />
         </span>}
        {!this.props.canWrite && <span className="right picker-right">{item.rangeOfKilometers ? `${item.rangeOfKilometers} Km` : ''}</span>}
      </span>
      }

      {config.languageChoice && item.active &&
      <ul className="list">
        <span>
          <div><br/>{this.renderLanguageChoice()}</div>
          {this.props.canWrite && <span>
          <li className={"list__footer" + (error[`${name}.description`] && error[`${name}.description`].message ? " error" : "")} >
            <LabelEncoder keys={Constants.SUPPORTED_LANGUAGES} onValidate={this.onLanguageChoiceValidation} mandatory={this.props.mandatoryDescription} values={this.state.item.description}>
                <Button className="btn btn-link js-dropdown-trigger add-more-btn">
                  <svg className="bmw-icon-sm mr-1" aria-hidden="true">
                    <use xlinkHref="#icon-plus"/>
                  </svg>
                  <strong>{formatMessage({id:'section.mobility.setDescription'})}</strong>
                </Button>
            </LabelEncoder>
          </li>
          {error[`${name}.description`] && error[`${name}.description`].message && (
            <div className={"txt-error"}>{formatMessage({id: error[`${name}.description`].message})}</div>
          )}
          </span>}
        </span>
      </ul>
      }
    </span>
  }
}

export default injectIntl(CheckboxItem);

CheckboxItem.propTypes ={
  name: PropTypes.string.isRequired,
  labelKey: PropTypes.string.isRequired,
  placeholderDurationKey: PropTypes.string,
  placeholderPriceKey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  item: PropTypes.shape({
    default: PropTypes.bool,
    active: PropTypes.bool,
    duration: PropTypes.string,
  }),
}



// WEBPACK FOOTER //
// ./src/components/dealership/CheckboxItem.js